import type { ApiCountryCode } from '../../api/types';

// Real, official Telegram country/phone-code data, bundled locally instead of fetched --
// `fetchCountryList` (`GramJs.help.GetCountriesList`) is a real MTProto call that never resolves
// under `DISABLE_REAL_MTPROTO` (the gramjs worker is never instantiated), and unlike the language
// pack gap (which degrades to English), this one leaves the phone-number country picker with
// literally zero countries to choose from -- blocking the entire phone-number login flow, not
// just a cosmetic translation gap. Sourced from the tg-im Android fork's own bundled
// `countries.txt` (Telegram's real, official data, already shipped in production on Android),
// excluding `YL` ("Y-land"), Telegram's own internal placeholder for test/staging DC servers.
export default async function readCountryList(): Promise<{
  phoneCodes: ApiCountryCode[];
  general: ApiCountryCode[];
}> {
  return (await import('../../assets/localization/countryList.json')).default;
}
